import type { PropsWithChildren, ReactNode } from "react";

import { Box } from "../../../../../../mads";

import { StyleSheet } from "react-native";

export type JobHeaderActionsProps = PropsWithChildren<{
  primaryApply: ReactNode;
  secondaryApply?: ReactNode | undefined;
  saveJob?: ReactNode | undefined;
  shareJob?: ReactNode | undefined;
  dislikeJob?: ReactNode | undefined;
}>;

export const JobHeaderActions: React.FC<JobHeaderActionsProps> = ({
  primaryApply,
  secondaryApply,
  saveJob,
  shareJob,
  // dislikeJob,
}) => {
  return (
    <Box sx={styles.actionsRow}>
      <Box sx={styles.primaryButton}>{primaryApply}</Box>
      <Box>{secondaryApply}</Box>
      <Box>{saveJob}</Box>
      {/* <Box>{dislikeJob}</Box> */}
      <Box>{shareJob}</Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  actionsRow: {
    display: "flex",
    flexDirection: "row",
    columnGap: 12,
    paddingTop: 16,
    paddingBottom: 24,
  },
  primaryButton: {},
});
